import type { FC } from 'react'
import { Button, Fabulous, type FabulousProps, useIsMobileVariant } from '@dhl-ui/components'
import { PlusIcon } from '@dhl-ui/icons'
import { usePageRefresh } from '@dhl-ui/page'

export type SingleCtaProps = {
  /**
   * No need for an adaptive button, instead pass me the button
   */
  isButton?: boolean

  label: string

  onClick: () => void

  isFullWidth?: boolean

  isDisabled?: boolean

  'data-testid'?: string
} & Pick<FabulousProps, 'position'>

/**
 * When you have only one single action on the page
 */
export const SingleCta: FC<SingleCtaProps> = ({
  isButton = false,
  label,
  isFullWidth,
  isDisabled,
  position,
  onClick,
  'data-testid': testid,
}) => {
  const isMobileVariant = useIsMobileVariant()
  const { isPulling } = usePageRefresh()

  if (isMobileVariant && !isButton) {
    return isPulling ? null : (
      <Fabulous
        onClick={onClick}
        aria-label={label}
        variant="extended"
        size="medium"
        data-testid={testid}
        position={position}
        isDisabled={isDisabled}
      >
        <PlusIcon />
        {label}
      </Fabulous>
    )
  }

  return (
    <Button
      onClick={onClick}
      startIcon={<PlusIcon />}
      variant="contained"
      color="primary"
      data-testid={testid}
      fullWidth={isFullWidth}
      disabled={isDisabled}
    >
      {label}
    </Button>
  )
}
